export default "__VITE_ASSET__OKH0tXVi__"